module.exports = __webpack_public_path__ + "img/bootstrap4-dark-purple.60a2e3d8.svg";